<template>
  <div class="error">
      <div class="errorImg"><img src="../images/home/404.png" alt=""></div>
      <div class="errorText">页面找不到啦！</div>
      <div class="backBtn" @click="backBtn">返回首页</div>
  </div>
</template>
<script>
export default {
  name:'error',
  methods:{
    backBtn(){
      this.$router.push('/');
    },
  }
}
</script>
<style lang="scss" scoped>
  @import '@/style/variables.scss';
  .error{
    padding:50px 0 150px;
    @include h-bgColor($colorFF);
    .errorImg{
      width: 600px;
      margin:4% auto 0;
    }
    .errorText{
      text-align: center;
      @include h-fontSize($color33,18px,30px);
    }
    .backBtn{
      cursor: pointer;
      margin:30px auto 0;
      transition: opacity 0.3s;
      @include h-btn(120px, 36px, 14px, $colorFF, 4px, 0, $colorE7, false, none);
      &:hover{
        opacity: 0.8;
      }
    }
  }
</style>
